export const translations = {
  en: {
    navigation: {
      deals: "Deals",
      promos: "Promo Codes",
      discussions: "Discussions",
      categories: "Categories",
      profile: "My Profile",
      sweepstakes: "Sweepstakes",
      moderation: "Moderation",
      savedItems: "Saved Items",
      myComments: "My Comments",
      notificationSettings: "Notification Settings",
      dealDetails: "Deal Details",
      promoDetails: "Promo Details",
      sweepstakeDetails: "Sweepstake Details",
    },
    filters: {
      title: "Filters",
      categories: "Categories",
      stores: "Stores",
      all: "All",
      status: "Status",
      active: "Active",
      expired: "Expired",
    },
    common: {
      search: "Search brands, products, etc.",
      loading: "Loading...",
      error: "Error loading data",
      noResults: "No results found",
      no_results_for_query: "No results found for your query.",
      enter_search_query: "Enter a search query to begin.",
      subcategories: "subcategories",
      menu: "Menu",
      popularCategories: "Popular Categories",
      add: "Add",
      feedback: "Feedback",
      deals: "Deals",
      deal: "Deal",
      promoCode: "Promo Code",
      promo_codes: "Promo Codes",
      sweepstakes: "Sweepstakes",
      profile: "Profile",
      notifications: "Notifications",
      items: "items",
      no_items_in_category: "No items in selected category",
      statusPending: "Pending Review",
      statusRejected: "Rejected",
      statusExpired: "Expired",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      show_inactive: "Show expired",
      hide_inactive: "Hide expired",
      no_deals_found_for_filters: "No deals found for your filters.",
      no_promos_found: "No promo codes found.",
      settings: "Settings",
      about_app: "About App",
      expires: "Expires:",
      confirm: "Confirm",
      cancel: "Cancel",
      delete: "Delete",
      back: "Back",
      retry: "Retry",
      comments: "Comments",
      popular: "Popular",
      newest: "Newest",
      expired: "Expired",
      affiliate_disclosure: "We may get paid by brands for deals, including promoted items.",
      end_of_results: "This is all results",
      published_by: "Published by",
      free: "FREE",
      rejected: "Rejected",
      pending_review: "Pending Review",
      link_copied: "Link copied to clipboard!",
      oldest: "Oldest",
    },
    auth: {
      signIn: "Sign In",
      signUp: "Sign Up",
      signOut: "Sign Out",
      login_required: "Login required",
      login_to_favorite: "Sign in to add to favorites.",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      forgotPassword: "Forgot Password?",
      rememberMe: "Remember me",
      resetPassword: "Reset Password",
      createAccount: "Create Account",
      alreadyHaveAccount: "Already have an account?",
      dontHaveAccount: "Don't have an account?",
      continueWithFacebook: "Continue with Facebook",
      invalid_email: "Please enter a valid email address",
      password_min_length: "Password must be at least 6 characters",
      passwords_do_not_match: "Passwords do not match",
      signup_success_redirect: "Registration completed successfully! You can now sign in.",
      signingOut: "Signing out...",
      or: "or",
      newPassword: "New Password",
      updatePassword: "Update Password",
      backToSignIn: "Back to Sign In",
      sendResetEmail: "Send Reset Email",
      resetEmailSent: "Reset email sent! Check your inbox.",
      welcome_title: "Welcome",
      create_account_title: "Create Account",
      create_new_password_title: "Create New Password",
      reset_password_title: "Reset Password",
      continue_with_facebook: "Continue with Facebook",
      enter_your_email: "Enter your email",
      or_continue_with: "Or continue with",
      email_placeholder: "Email address",
      password_placeholder: "Password",
      confirm_new_password_placeholder: "Confirm new password",
      remember_me: "Remember me",
      forgot_password: "Forgot password?",
      no_account: "No account?",
      already_have_account: "Already have an account?",
      password_updated_successfully: "Your password has been updated successfully",
      reset_password_instructions_sent: "Password reset instructions sent to your email",
      account_created_check_email: "Account created! Please check your email to confirm before logging in.",
      agree_to_privacy_policy_part1: "By continuing, you agree to our",
      privacy_policy: "Privacy Policy",
    },
    authErrors: {
      email_not_confirmed: "Email not confirmed",
      invalid_login: "Invalid email or password",
      user_not_found: "User not found",
      password_incorrect: "Incorrect password",
      account_blocked: "Account is blocked",
      too_many_attempts: "Too many attempts. Please try again later.",
      user_already_registered: "User already registered with this email",
      unknown: "Unknown authentication error"
    },
    settings: {
      title: "Settings",
      theme: "Theme",
      language: "Language",
      changePassword: "Change Password",
      deleteAccount: "Delete Account",
      dark: "Dark",
      light: "Light",
      selectLanguage: "Select Language",
      confirmPasswordResetTitle: "Change Password",
      confirmPasswordResetText: "We'll send instructions to your email.",
      confirmDeleteAccountTitle: "Delete Account",
      confirmDeleteAccountText: "Are you sure? This action is irreversible.",
      passwordResetSent: "Password reset email sent!",
      accountDeleted: "Account deleted successfully.",
      nameUpdated: "Name updated successfully!",
      signingOut: "Signing out...",
    },
    electronics: "Electronics",
    "home-garden": "Home & Garden",
    clothing: "Clothing & Shoes",
    toys: "Toys",
    auto: "Automotive",
    kids: "Kids",
    "beauty-health": "Beauty & Health",
    food: "Food",
    sports: "Sports & Outdoors",
    entertainment: "Entertainment",
    finance: "Finance",
    services: "Services",
    other: "Other",
    loading: {
      deals: "Loading deals...",
      promos: "Loading promo codes...",
      searching: "Searching...",
    },
    stores: {
      unknown: "Unknown Store",
      free: "FREE",
    },
    images: {
      no_image: "No Image"
    },
    deals: {
      untitled: "Untitled Deal",
      free: "FREE",
    },
    promos: {
      disclosure: "We may get paid by brands for deals, including promoted items.",
      untitled: "Untitled Promo Code",
      login_to_see_code: "Log in to see code",
      check_out_promo: "Check out this promo code:",
    },
    categories: {
      unknown: "Unknown Category"
    },
    users: {
      anonymous: "Anonymous",
      someone: "Someone",
    },
    errors: {
      db_client_not_initialized: "Database client not initialized.",
      failed_to_load_deals_list: "Failed to load deals list.",
      failed_to_load_promos: "Failed to load promo codes.",
      error: "Error",
      copy_failed: "Failed to copy code.",
      favorite_failed: "Failed to update favorites.",
      share_failed: "Failed to share: ",
      deal_not_found_title: "Deal Not Found",
      deal_not_found_message: "This deal may have been removed or expired.",
      promo_not_found_title: "Promo Code Not Found",
      promo_not_found_message: "This promo code may have been removed or expired.",
      sweepstake_not_found_title: "Sweepstake Not Found",
      sweepstake_not_found_message: "This sweepstake may have been removed or ended.",
      comment_not_found_title: "Comment Not Found",
      comment_not_found_message: "This comment may have been deleted.",
      page_not_found_title: "Page Not Found",
      page_not_found_message: "The page you are looking for could not be found.",
      network_title: "Connection Error",
      network_message: "Please check your internet connection and try again.",
      generic_title: "Something went wrong",
      generic_message: "An unexpected error occurred. Please try again.",
      operationFailed: "Operation failed.",
      deleteAccountFailed: "Failed to delete account.",
      failed_to_load_sweepstakes: "Failed to load sweepstakes.",
    },
    comment: {
      delete_error: "Failed to delete comment. Please try again.",
    },
    comments: {
      empty: "No comments yet",
      be_first: "Be the first!",
      show_replies: "Show replies",
      show_more_replies: "Show more replies",
    },
    buttons: {
      retry: "Retry",
      copied: "Copied!",
      copy: "Copy",
      to_discount: "To offer",
      get_discount: "Get Discount",
      viewDealShort: "View",
      enter: "Enter",
      enter_sweepstake: "Enter Sweepstakes",
      login_to_enter: "Sign in to enter",
      visit_store: "Visit Store",
      copy_code: "Copy Code",
      my_comments: "My Comments",
      notifications: "Notifications",
      my_subscriptions: "My Subscriptions",
      user_settings: "User Settings",
      cancel: "Cancel",
      send: "Send",
      sending: "Sending...",
      delete: "Delete",
      deleting: "Deleting...",
      update_password: "Update Password",
      send_instructions: "Send Instructions",
      register: "Register",
      login: "Login",
      back_to_login: "Back to Login",
      reply: "Reply",
      comment: "Comment",
      add_image: "Add image",
    },
    placeholder: {
      screen: {
        message: "This is a temporary placeholder."
      }
    },
    app: {
      test_message: "This is a test message from t()"
    },
    tabs: {
      hot: "HOT",
      new: "NEW",
      discussed: "MOST DISCUSSED",
      free: "FREE",
      deals: "Deals",
      promo_codes: "Promo Codes",
      sweepstakes: "Sweepstakes",
    },
    time: {
      na: "N/A",
      invalid_date: "Invalid date",
      just_now: "just now",
      minutes_ago: "{{minutes}}m ago",
      hours_ago: "{{hours}}h ago",
      days_ago: "{{days}}d ago",
      minutes_ago_short: "{val}m ago",
      hours_ago_short: "{val}h ago",
      days_ago_short: "{val}d ago",
      expires_on: "Expires on {{date}}",
      expired_on: "Expired on {{date}}",
    },
    userComments: {
      noCommentsInCategory: "You have no comments in this category yet.",
      searchPlaceholder: "Search comments...",
      confirmDelete: "Are you sure you want to delete this comment?",
      yourComment: "Your comment",
    },
    userPostedItems: {
      noItemsInCategory: "You have no items in this category yet.",
    },
    savedItems: {
      noItemsInCategory: "You have no saved items in this category yet.",
      no_deals: "No saved deals here yet.",
      no_promos: "No saved promo codes here yet.", 
      no_sweepstakes: "No saved sweepstakes here yet.",
    },

    profile: {
      myProfile: "My Profile",
      myComments: "My Comments",
      myPostedItems: "My Posted Items",
      savedItems: "Saved Items",
      settings: "Settings",
      subscriptions: "Subscriptions",
      status: "Status",
      rating: "Rating",
      status_info: "Status Information",
      contributions: "posts",
      contributions_master: "{{count}}/1000+ posts",
      contributions_progress: "{{current}}/{{next}} posts ({{percent}}%)",
      status_tooltip_header: "Your Status",
      appVersion: "App version",
      special_status: "Special status",
    },
    dealDetail: {
      title: "Deal Details",
      description: "Description",
      comments: "Comments",
      addComment: "Add Comment",
      share: "Share",
      favorite: "Favorite",
    },
    sweepstakeDetail: {
      title: "Sweepstake Details",
      description: "Description",
      comments: "Comments",
      addComment: "Add Comment",
      share: "Share",
      favorite: "Favorite",
    },
    promoDetail: {
      title: "Promo Details",
      codeCopied: "Code copied!",
    },
    search: {
      results: "Search Results",
      results_title_prefix: "Results",
      results_title_empty: "Search Results",
    },
    notificationSettings: {
      title: "Notification Settings",
      signInRequired: "Please sign in to access notification settings.",
      loadError: "Failed to load notification settings.",
      saveError: "Failed to save settings. Changes have been reverted.",
      pushNotifications: "Push Notifications",
      chooseNotifications: "Choose what notifications you want to receive",
      mentions: "Mentions",
      mentionsDesc: "When someone mentions you in a comment",
      replies: "Replies",
      repliesDesc: "When someone replies to your comment",
      subscriptions: "Subscriptions",
      subscriptionsDesc: "When new content matches your keywords",
      newOffers: "New Offers",
      newOffersDesc: "Get notified about new deals, promos and sweepstakes",
      votes: "Votes",
      votesDesc: "When someone votes on your content",
      favorites: "Favorites",
      favoritesDesc: "When someone adds your content to favorites",
      keywords: "Keywords",
      keywordsDesc: "Keyword-based notifications",
      emailNotifications: "Email Notifications",
      receiveViaEmail: "Receive notifications via email",
      emailUpdates: "Email Updates",
      emailUpdatesDesc: "Receive notifications in your email",
      keywordNotifications: "Keyword Email Notifications",
      keywordNotificationsDesc: "Email notifications for keywords",
    },
    header: {
      searchPlaceholder: "Search...",
    },
    notifications: {
      loading: "Loading notifications...",
      empty_title: "All quiet",
      empty_message: "Notifications will appear here",
      mark_all_read: "Read all",
      new_content_keyword: "New content for keyword: {{content}}",
      mentioned_you: "{{actor}} mentioned you in a comment",
      replied_to_comment: "{{actor}} replied to your comment",
      commented_on_post: "{{actor}} commented on your post",
      voted_on_comment: "{{actor}} voted on your comment",
    },
    commentInput: {
      replying_to: "Replying to:",
      reply_placeholder: "Write a reply...",
      placeholder: "Write a comment...",
    },
    testing: {
      title: "Testing",
      subtitle: "Developer Tools",
    },
    splash: {
      loading: "Loading app..."
    },
  },
  ru: {
    navigation: {
      deals: "Скидки",
      promos: "Промокоды",
      discussions: "Обсуждения",
      categories: "Категории",
      profile: "Мой профиль",
      sweepstakes: "Розыгрыши",
      moderation: "Модерация",
      savedItems: "Сохраненное",
      myComments: "Мои комментарии",
      notificationSettings: "Настройки уведомлений",
      dealDetails: "Детали скидки",
      promoDetails: "Детали промокода",
      sweepstakeDetails: "Детали розыгрыша",
    },
    filters: {
      title: "Фильтры",
      categories: "Категории",
      stores: "Магазины",
      all: "Все",
      status: "Статус",
      active: "Активные",
      expired: "Истекшие",
    },
    common: {
      search: "Поиск брендов, товаров и т.д.",
      loading: "Загрузка...",
      error: "Ошибка загрузки данных",
      noResults: "Ничего не найдено",
      no_results_for_query: "По вашему запросу ничего не найдено.",
      enter_search_query: "Введите запрос для начала поиска.",
      subcategories: "подкатегорий",
      menu: "Меню",
      popularCategories: "Популярные категории",
      add: "Добавить",
      feedback: "Обратная связь",
      deals: "Скидки",
      deal: "Скидку",
      promoCode: "Промокод",
      promo_codes: "Промокоды",
      sweepstakes: "Розыгрыши",
      profile: "Профиль",
      notifications: "Уведомления",
      items: "товаров",
      no_items_in_category: "Нет элементов в выбранной категории",
      statusPending: "На модерации",
      statusRejected: "Отклонен",
      statusExpired: "Истёк",
      darkMode: "Темная тема",
      lightMode: "Светлая тема",
      show_inactive: "Показывать просроченные",
      hide_inactive: "Скрывать просроченные",
      no_deals_found_for_filters: "По вашим фильтрам скидок не найдено.",
      no_promos_found: "Промокодов не найдено.",
      settings: "Настройки",
      about_app: "О приложении",
      expires: "Истекает:",
      confirm: "Подтвердите действие",
      cancel: "Отмена",
      delete: "Удалить",
      back: "Назад",
      retry: "Повторить",
      comments: "Комментарии",
      popular: "Популярные",
      newest: "Новые",
      expired: "Истекло",
      affiliate_disclosure: "Мы можем получать вознаграждение от брендов за сделки, включая продвигаемые товары.",
      end_of_results: "Это все результаты",
      published_by: "Разместил(а)",
      free: "БЕСПЛАТНО",
      rejected: "Отклонено",
      pending_review: "На модерации",
      link_copied: "Ссылка скопирована в буфер обмена!",
      oldest: "Сначала старые",
    },
    auth: {
      signIn: "Войти",
      signUp: "Регистрация",
      signOut: "Выйти",
      login_required: "Необходим вход",
      login_to_favorite: "Войдите, чтобы добавить в избранное.",
      email: "Email",
      password: "Пароль",
      confirmPassword: "Подтвердите пароль",
      forgotPassword: "Забыли пароль?",
      rememberMe: "Запомнить меня",
      resetPassword: "Сбросить пароль",
      createAccount: "Создать аккаунт",
      alreadyHaveAccount: "Уже есть аккаунт?",
      dontHaveAccount: "Нет аккаунта?",
      continueWithFacebook: "Продолжить через Facebook",
      invalid_email: "Пожалуйста, введите корректный email адрес",
      password_min_length: "Пароль должен содержать не менее 6 символов",
      passwords_do_not_match: "Пароли не совпадают",
      signup_success_redirect: "Регистрация успешно завершена! Можете войти.",
      signingOut: "Выходим...",
      or: "или",
      newPassword: "Новый пароль",
      updatePassword: "Обновить пароль",
      backToSignIn: "Вернуться ко входу",
      sendResetEmail: "Отправить письмо для сброса",
      resetEmailSent: "Письмо для сброса отправлено! Проверьте почту.",
      welcome_title: "Добро пожаловать",
      create_account_title: "Создание аккаунта",
      create_new_password_title: "Создание нового пароля",
      reset_password_title: "Сброс пароля",
      continue_with_facebook: "Продолжить с Facebook",
      enter_your_email: "Введите ваш email",
      or_continue_with: "Или продолжить с",
      email_placeholder: "Email адрес",
      password_placeholder: "Пароль",
      confirm_new_password_placeholder: "Подтвердите новый пароль",
      remember_me: "Запомнить меня",
      forgot_password: "Забыли пароль?",
      no_account: "Нет аккаунта?",
      already_have_account: "Уже есть аккаунт?",
      password_updated_successfully: "Ваш пароль был успешно обновлен",
      reset_password_instructions_sent: "Инструкции по сбросу пароля отправлены на ваш email",
      account_created_check_email: "Аккаунт создан! Проверьте ваш email для подтверждения.",
      agree_to_privacy_policy_part1: "Продолжая, вы соглашаетесь с нашей",
      privacy_policy: "Политикой конфиденциальности",
    },
    authErrors: {
      email_not_confirmed: "Email не подтвержден",
      invalid_login: "Неверный email или пароль",
      user_not_found: "Пользователь не найден",
      password_incorrect: "Неверный пароль",
      account_blocked: "Аккаунт заблокирован",
      too_many_attempts: "Слишком много попыток. Попробуйте позже.",
      user_already_registered: "Пользователь с таким email уже зарегистрирован",
      unknown: "Неизвестная ошибка авторизации"
    },
    settings: {
      title: "Настройки",
      theme: "Тема",
      language: "Язык",
      changePassword: "Изменить пароль",
      deleteAccount: "Удалить аккаунт",
      dark: "Темная",
      light: "Светлая",
      selectLanguage: "Выберите язык",
      confirmPasswordResetTitle: "Изменить пароль",
      confirmPasswordResetText: "Мы отправим инструкции на ваш email.",
      confirmDeleteAccountTitle: "Удалить аккаунт",
      confirmDeleteAccountText: "Вы уверены? Это действие необратимо.",
      passwordResetSent: "Письмо для сброса пароля отправлено!",
      accountDeleted: "Аккаунт успешно удален.",
      nameUpdated: "Имя успешно обновлено!",
      signingOut: "Выходим...",
    },
    electronics: "Электроника",
    "home-garden": "Дом и сад",
    clothing: "Одежда и обувь",
    toys: "Игрушки",
    auto: "Автомобили",
    kids: "Детские товары",
    "beauty-health": "Красота и здоровье",
    food: "Продукты питания",
    sports: "Спорт и отдых",
    entertainment: "Развлечения",
    finance: "Финансы",
    services: "Услуги",
    other: "Другое",
    loading: {
      deals: "Загрузка скидок...",
      promos: "Загрузка промокодов...",
      searching: "Идет поиск...",
    },
    stores: {
      unknown: "Неизвестный магазин",
      free: "БЕСПЛАТНО",
    },
    images: {
      no_image: "Нет изображения"
    },
    deals: {
      untitled: "Без названия",
      free: "БЕСПЛАТНО",
    },
    promos: {
      disclosure: "Мы можем получать вознаграждение от брендов за сделки, включая продвигаемые товары.",
      untitled: "Промокод без названия",
      login_to_see_code: "Войдите, чтобы увидеть код",
      check_out_promo: "Посмотрите этот промокод:",
    },
    categories: {
      unknown: "Неизвестная категория"
    },
    users: {
      anonymous: "Аноним",
      someone: "Кто-то",
    },
    errors: {
      db_client_not_initialized: "Клиент базы данных не инициализирован.",
      failed_to_load_deals_list: "Не удалось загрузить список скидок.",
      failed_to_load_promos: "Не удалось загрузить промокоды.",
      error: "Ошибка",
      copy_failed: "Не удалось скопировать код.",
      favorite_failed: "Не удалось обновить избранное.",
      share_failed: "Не удалось поделиться: ",
      deal_not_found_title: "Скидка не найдена",
      deal_not_found_message: "Эта скидка могла быть удалена или истекла.",
      promo_not_found_title: "Промокод не найден",
      promo_not_found_message: "Этот промокод мог быть удален или истек.",
      sweepstake_not_found_title: "Розыгрыш не найден",
      sweepstake_not_found_message: "Этот розыгрыш мог быть удален или завершен.",
      comment_not_found_title: "Комментарий не найден",
      comment_not_found_message: "Этот комментарий мог быть удален.",
      page_not_found_title: "Страница не найдена",
      page_not_found_message: "Запрашиваемая страница не найдена.",
      network_title: "Ошибка соединения",
      network_message: "Проверьте подключение к интернету и попробуйте снова.",
      generic_title: "Что-то пошло не так",
      generic_message: "Произошла неожиданная ошибка. Попробуйте снова.",
      operationFailed: "Операция завершилась неудачей.",
      deleteAccountFailed: "Не удалось удалить аккаунт.",
      failed_to_load_sweepstakes: "Не удалось загрузить розыгрыши.",
    },
    comment: {
      delete_error: "Не удалось удалить комментарий. Попробуйте снова.",
    },
    comments: {
      empty: "Комментариев пока нет",
      be_first: "Будьте первым!",
      show_replies: "Показать ответы",
      show_more_replies: "Показать больше ответов",
    },
    buttons: {
      retry: "Повторить",
      copied: "Скопировано!",
      copy: "Копировать",
      to_discount: "К предложению",
      get_discount: "Получить скидку",
      viewDealShort: "Смотреть",
      enter: "Участвовать",
      enter_sweepstake: "Участвовать в розыгрыше",
      login_to_enter: "Войдите, чтобы участвовать",
      visit_store: "Перейти в магазин",
      copy_code: "Копировать код",
      my_comments: "Мои комментарии",
      notifications: "Уведомления",
      my_subscriptions: "Мои подписки",
      user_settings: "Настройки пользователя",
      cancel: "Отмена",
      send: "Отправить",
      sending: "Отправляем...",
      delete: "Удалить",
      deleting: "Удаляем...",
      update_password: "Обновить пароль",
      send_instructions: "Отправить инструкции",
      register: "Регистрация",
      login: "Вход",
      back_to_login: "Вернуться ко входу",
      reply: "Ответить",
      comment: "Комментировать",
      add_image: "Добавить изображение",
    },
    placeholder: {
      screen: {
        message: "Это временная заглушка."
      }
    },
    app: {
      test_message: "Это тестовое сообщение от t()"
    },
    tabs: {
      hot: "Горячие",
      new: "Новые",
      discussed: "Обсуждаемые",
      free: "Бесплатные",
      deals: "Скидки",
      promo_codes: "Промокоды",
      sweepstakes: "Розыгрыши",
    },
    time: {
      na: "Н/Д",
      invalid_date: "Неверная дата",
      just_now: "только что",
      minutes_ago: "{{minutes}}м назад",
      hours_ago: "{{hours}}ч назад",
      days_ago: "{{days}}д назад",
      minutes_ago_short: "{val}м назад",
      hours_ago_short: "{val}ч назад",
      days_ago_short: "{val}дн назад",
      expires_on: "Истекает {{date}}",
      expired_on: "Истекло {{date}}",
    },
    userComments: {
      noCommentsInCategory: "У вас пока нет комментариев в этой категории.",
      searchPlaceholder: "Поиск комментариев...",
      confirmDelete: "Вы уверены, что хотите удалить этот комментарий?",
      yourComment: "Ваш комментарий",
    },
    userPostedItems: {
      noItemsInCategory: "У вас пока нет элементов в этой категории.",
    },
    savedItems: {
      noItemsInCategory: "У вас пока нет сохраненных элементов в этой категории.",
      no_deals: "Здесь пока нет сохраненных сделок.",
      no_promos: "Здесь пока нет сохраненных промокодов.",
      no_sweepstakes: "Здесь пока нет сохраненных розыгрышей.",
    },
    profile: {
      myProfile: "Мой профиль",
      myComments: "Мои комментарии",
      myPostedItems: "Мои публикации",
      savedItems: "Сохраненное",
      settings: "Настройки",
      subscriptions: "Подписки",
      status: "Статус",
      rating: "Рейтинг",
      status_info: "Информация о статусе",
      contributions: "публикаций",
      special_status: "Особый статус",
      contributions_master: "{{count}}/1000+ публикаций",
      contributions_progress: "{{current}}/{{next}} публикаций ({{percent}}%)",
      status_tooltip_header: "Ваш статус",
      appVersion: "Версия приложения",
    },
    dealDetail: {
      title: "Детали скидки",
      description: "Описание",
      comments: "Комментарии",
      addComment: "Добавить комментарий",
      share: "Поделиться",
      favorite: "В избранное",
    },
    sweepstakeDetail: {
      title: "Детали розыгрыша",
      description: "Описание",
      comments: "Комментарии",
      addComment: "Добавить комментарий",
      share: "Поделиться",
      favorite: "В избранное",
    },
    promoDetail: {
      title: "Детали промокода",
      codeCopied: "Код скопирован!",
    },
    search: {
      results: "Результаты поиска",
      results_title_prefix: "Результаты",
      results_title_empty: "Результаты поиска",
    },
    notificationSettings: {
      title: "Настройки уведомлений",
      signInRequired: "Войдите, чтобы получить доступ к настройкам уведомлений.",
      loadError: "Не удалось загрузить настройки уведомлений.",
      saveError: "Не удалось сохранить настройки. Изменения отменены.",
      pushNotifications: "Push-уведомления",
      chooseNotifications: "Выберите, какие уведомления вы хотите получать",
      mentions: "Упоминания",
      mentionsDesc: "Когда кто-то упоминает вас в комментарии",
      replies: "Ответы",
      repliesDesc: "Когда кто-то отвечает на ваш комментарий",
      subscriptions: "Подписки",
      subscriptionsDesc: "Когда новый контент соответствует вашим ключевым словам",
      newOffers: "Новые предложения",
      newOffersDesc: "Получайте уведомления о новых скидках, промокодах и розыгрышах",
      votes: "Голоса",
      votesDesc: "Когда кто-то голосует за ваш контент",
      favorites: "Избранное",
      favoritesDesc: "Когда кто-то добавляет ваш контент в избранное",
      keywords: "Ключевые слова",
      keywordsDesc: "Уведомления по ключевым словам",
      emailNotifications: "Email-уведомления",
      receiveViaEmail: "Получайте уведомления на электронную почту",
      emailUpdates: "Email-обновления",
      emailUpdatesDesc: "Получать уведомления на электронную почту",
      keywordNotifications: "Email уведомления по ключевым словам",
      keywordNotificationsDesc: "Email уведомления по ключевым словам",
    },
    header: {
      searchPlaceholder: "Поиск...",
    },
    notifications: {
      loading: "Загрузка уведомлений...",
      empty_title: "Пока тихо",
      empty_message: "Уведомления появятся здесь",
      mark_all_read: "Прочитать всё",
      new_content_keyword: "Новый контент по ключевому слову: {{content}}",
      mentioned_you: "{{actor}} упомянул вас в комментарии",
      replied_to_comment: "{{actor}} ответил на ваш комментарий",
      commented_on_post: "{{actor}} оставил комментарий к вашей публикации",
      voted_on_comment: "{{actor}} оценил ваш комментарий",
    },
    commentInput: {
      replying_to: "Отвечаете:",
      reply_placeholder: "Написать ответ...",
      placeholder: "Написать комментарий...",
    },
    testing: {
      title: "Тестирование",
      subtitle: "Инструменты разработчика",
    },
    splash: {
      loading: "Загрузка приложения..."
    },
  },
  es: {
    navigation: {
      deals: "Ofertas",
      promos: "Códigos Promo",
      discussions: "Discusiones",
      categories: "Categorías",
      profile: "Mi Perfil",
      sweepstakes: "Sorteos",
      moderation: "Moderación",
      savedItems: "Guardados",
      myComments: "Mis Comentarios",
      notificationSettings: "Configuración de Notificaciones",
      dealDetails: "Detalles de la Oferta",
      promoDetails: "Detalles del Código Promo",
      sweepstakeDetails: "Detalles del Sorteo",
    },
    filters: {
      title: "Filtros",
      categories: "Categorías",
      stores: "Tiendas",
      all: "Todos",
      status: "Estado",
      active: "Activo",
      expired: "Expirado",
    },
    common: {
      search: "Buscar marcas, productos, etc.",
      loading: "Cargando...",
      error: "Error al cargar datos",
      noResults: "No se encontraron resultados",
      no_results_for_query: "No se encontraron resultados para tu búsqueda.",
      enter_search_query: "Ingresa una búsqueda para comenzar.",
      subcategories: "subcategorías",
      menu: "Menú",
      popularCategories: "Categorías Populares",
      add: "Agregar",
      feedback: "Comentarios",
      deal: "Oferta",
      promoCode: "Código Promo",
      items: "items",
      no_items_in_category: "No hay elementos en la categoría seleccionada",
      statusPending: "Pendiente de revisión",
      statusRejected: "Rechazado",
      statusExpired: "Expirado",
      darkMode: "Modo Oscuro",
      lightMode: "Modo Claro",
      show_inactive: "Mostrar expirado",
      hide_inactive: "Ocultar expirado",
      no_deals_found_for_filters: "No se encontraron ofertas para tus filtros.",
      no_promos_found: "No se encontraron códigos promo.",
      settings: "Configuración",
      about_app: "Acerca de la aplicación",
      expires: "Expira:",
      confirm: "Confirmar",
      cancel: "Cancelar",
      delete: "Eliminar",
      deals: "Ofertas",
      promo_codes: "Códigos Promo",
      sweepstakes: "Sorteos",
      profile: "Perfil",
      notifications: "Notificaciones",
      comments: "Comentarios",
      popular: "Populares",
      newest: "Más recientes",
      expired: "Expirado",
      affiliate_disclosure: "Es posible que las marcas nos paguen por las ofertas, incluidos los artículos promocionados.",
      end_of_results: "Estos son todos los resultados",
      published_by: "Publicado por",
      free: "GRATIS",
      rejected: "Rechazado",
      pending_review: "Pendiente de Revisión",
      link_copied: "¡Enlace copiado al portapapeles!",
      oldest: "Más antiguas",
    },
    auth: {
      signIn: "Iniciar Sesión",
      signUp: "Registrarse",
      signOut: "Cerrar Sesión",
      login_required: "Inicio de sesión requerido",
      login_to_favorite: "Inicia sesión para agregar a favoritos.",
      email: "Email",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      forgotPassword: "¿Olvidaste tu contraseña?",
      rememberMe: "Recordarme",
      resetPassword: "Restablecer Contraseña",
      createAccount: "Crear Cuenta",
      alreadyHaveAccount: "¿Ya tienes una cuenta?",
      dontHaveAccount: "¿No tienes una cuenta?",
      continueWithFacebook: "Continuar con Facebook",
      invalid_email: "Por favor ingresa una dirección de email válida",
      password_min_length: "La contraseña debe tener al menos 6 caracteres",
      passwords_do_not_match: "Las contraseñas no coinciden",
      signup_success_redirect: "¡Registro completado exitosamente! Ya puedes iniciar sesión.",
      signingOut: "Cerrando sesión...",
      or: "o",
      newPassword: "Nueva Contraseña",
      updatePassword: "Actualizar Contraseña",
      backToSignIn: "Volver al Inicio de Sesión",
      sendResetEmail: "Enviar Email de Restablecimiento",
      resetEmailSent: "¡Email de restablecimiento enviado! Revisa tu bandeja de entrada.",
      welcome_title: "Bienvenido",
      create_account_title: "Crear cuenta",
      create_new_password_title: "Crear nueva contraseña",
      reset_password_title: "Restablecer contraseña",
      continue_with_facebook: "Continuar con Facebook",
      enter_your_email: "Ingresa tu email",
      or_continue_with: "O continuar con",
      email_placeholder: "Dirección de email",
      password_placeholder: "Contraseña",
      confirm_new_password_placeholder: "Confirma la nueva contraseña",
      remember_me: "Recordarme",
      forgot_password: "¿Olvidaste tu contraseña?",
      no_account: "¿No tienes una cuenta?",
      already_have_account: "¿Ya tienes una cuenta?",
      password_updated_successfully: "Tu contraseña se ha actualizado correctamente",
      reset_password_instructions_sent: "Las instrucciones para restablecer la contraseña se enviaron a tu email",
      account_created_check_email: "¡Cuenta creada! Por favor revisa tu email para confirmar antes de iniciar sesión.",
      agree_to_privacy_policy_part1: "Al continuar, aceptas nuestra",
      privacy_policy: "Política de Privacidad",
    },
    authErrors: {
      email_not_confirmed: "Email not confirmed",
      invalid_login: "Invalid email or password",
      user_not_found: "User not found",
      password_incorrect: "Incorrect password",
      account_blocked: "Account is blocked",
      too_many_attempts: "Too many attempts. Please try again later.",
      user_already_registered: "User already registered with this email",
      unknown: "Unknown authentication error"
    },
    settings: {
      title: "Configuración",
      theme: "Tema",
      language: "Idioma",
      changePassword: "Cambiar Contraseña",
      deleteAccount: "Eliminar Cuenta",
      dark: "Oscuro",
      light: "Claro",
      selectLanguage: "Seleccionar Idioma",
      confirmPasswordResetTitle: "Cambiar Contraseña",
      confirmPasswordResetText: "Enviaremos instrucciones a tu email.",
      confirmDeleteAccountTitle: "Eliminar Cuenta",
      confirmDeleteAccountText: "¿Estás seguro? Esta acción es irreversible.",
      passwordResetSent: "¡Email de restablecimiento de contraseña enviado!",
      accountDeleted: "Cuenta eliminada exitosamente.",
      nameUpdated: "¡Nombre actualizado exitosamente!",
      signingOut: "Cerrando sesión...",
    },
    electronics: "Electrónica",
    "home-garden": "Hogar y Jardín",
    clothing: "Ropa y Calzado",
    toys: "Juguetes",
    auto: "Automotriz",
    kids: "Productos para Niños",
    "beauty-health": "Belleza y Salud",
    food: "Alimentos",
    sports: "Deportes y Aire Libre",
    entertainment: "Entretenimiento",
    finance: "Finanzas",
    services: "Servicios",
    other: "Otros",
    loading: {
      deals: "Cargando ofertas...",
      promos: "Cargando códigos promo...",
      searching: "Buscando...",
    },
    stores: {
      unknown: "Tienda desconocida",
      free: "GRATIS",
    },
    images: {
      no_image: "Sin imagen"
    },
    deals: {
      untitled: "Oferta sin título",
      free: "GRATIS",
    },
    promos: {
      disclosure: "Podemos recibir compensación de marcas por ofertas, incluyendo ofertas promocionales.",
      untitled: "Código promo sin título",
      login_to_see_code: "Inicia sesión para ver el código",
      check_out_promo: "Mira este código promocional:",
    },
    categories: {
      unknown: "Categoría desconocida"
    },
    users: {
      anonymous: "Anónimo",
      someone: "Alguien",
    },
    errors: {
      db_client_not_initialized: "Cliente de base de datos no inicializado.",
      failed_to_load_deals_list: "Error al cargar la lista de ofertas.",
      failed_to_load_promos: "Error al cargar los códigos promo.",
      error: "Error",
      copy_failed: "No se pudo copiar el código.",
      favorite_failed: "No se pudo actualizar favoritos.",
      share_failed: "No se pudo compartir: ",
      operationFailed: "Operación falló.",
      deleteAccountFailed: "No se pudo eliminar la cuenta.",
      failed_to_load_sweepstakes: "Error al cargar los sorteos.",
    },
    comment: {
      delete_error: "No se pudo eliminar el comentario. Inténtalo de nuevo.",
    },
    comments: {
      empty: "Aún no hay comentarios",
      be_first: "¡Sé el primero!",
      show_replies: "Mostrar respuestas",
      show_more_replies: "Mostrar más respuestas",
    },
    buttons: {
      retry: "Reintentar",
      copied: "¡Copiado!",
      copy: "Copiar",
      to_discount: "Ir a la Oferta",
      get_discount: "Obtener Descuento",
      viewDealShort: "Ver",
      enter: "Participar",
      enter_sweepstake: "Participar en el Sorteo",
      login_to_enter: "Inicia sesión para participar",
      visit_store: "Visitar Tienda",
      copy_code: "Copiar Código",
      my_comments: "Mis Comentarios",
      notifications: "Notificaciones",
      my_subscriptions: "Mis Suscripciones",
      user_settings: "Configuración de Usuario",
      cancel: "Cancelar",
      send: "Enviar",
      sending: "Enviando...",
      delete: "Eliminar",
      deleting: "Eliminando...",
      update_password: "Actualizar contraseña",
      send_instructions: "Enviar instrucciones",
      register: "Registrarse",
      login: "Iniciar Sesión",
      back_to_login: "Volver al inicio de sesión",
      reply: "Responder",
      comment: "Comentar",
      add_image: "Agregar imagen",
    },
    placeholder: {
      screen: {
        message: "Esto es un marcador de posición temporal."
      }
    },
    app: {
      test_message: "Este es un mensaje de prueba de t()"
    },
    tabs: {
      hot: "Calientes",
      new: "Nuevas",
      discussed: "Más Discutidas",
      free: "Gratis",
      deals: "Ofertas",
      promo_codes: "Códigos Promo",
      sweepstakes: "Sorteos",
    },
    time: {
      na: "N/A",
      invalid_date: "Fecha inválida",
      just_now: "justo ahora",
      minutes_ago: "hace {{minutes}}m",
      hours_ago: "hace {{hours}}h",
      days_ago: "hace {{days}}d",
      minutes_ago_short: "hace {val}m",
      hours_ago_short: "hace {val}h",
      days_ago_short: "hace {val}d",
      expires_on: "Expira el {{date}}",
      expired_on: "Expirado el {{date}}",
    },
    userComments: {
      noCommentsInCategory: "Aún no tienes comentarios en esta categoría.",
      searchPlaceholder: "Buscar comentarios...",
      confirmDelete: "¿Estás seguro de que quieres eliminar este comentario?",
      yourComment: "Tu comentario",
    },
    userPostedItems: {
      noItemsInCategory: "Aún no tienes elementos en esta categoría.",
    },
    savedItems: {
      noItemsInCategory: "Aún no tienes elementos guardados en esta categoría.",
      no_deals: "Aún no hay ofertas guardadas aquí.",
      no_promos: "Aún no hay códigos promo guardados aquí.",
      no_sweepstakes: "Aún no hay sorteos guardados aquí.",
    },
    profile: {
      myProfile: "Mi Perfil",
      myComments: "Mis Comentarios",
      myPostedItems: "Mis Publicaciones",
      savedItems: "Guardados",
      settings: "Configuración",
      subscriptions: "Suscripciones",
      status: "Estado",
      rating: "Calificación",
      status_info: "Información del Estado",
      contributions: "contribuciones",
      special_status: "Estado Especial",
      contributions_master: "{{count}}/1000+ contribuciones",
      contributions_progress: "{{current}}/{{next}} contribuciones ({{percent}}%)",
      status_tooltip_header: "Tu estado",
      appVersion: "Versión de la aplicación",
    },
    dealDetail: {
      title: "Detalles de la Oferta",
      description: "Descripción",
      comments: "Comentarios",
      addComment: "Agregar comentario",
      share: "Compartir",
      favorite: "Favorito",
    },
    sweepstakeDetail: {
      title: "Detalles del Sorteo",
      description: "Descripción",
      comments: "Comentarios",
      addComment: "Agregar Comentario",
      share: "Compartir",
      favorite: "Favorito",
    },
    promoDetail: {
      title: "Detalles del Código Promo",
      codeCopied: "¡Código copiado!",
    },
    search: {
      results: "Resultados de Búsqueda",
      results_title_prefix: "Resultados",
      results_title_empty: "Resultados de Búsqueda",
    },
    notificationSettings: {
      title: "Configuración de Notificaciones",
      signInRequired: "Inicia sesión para acceder a la configuración de notificaciones.",
      loadError: "No se pudieron cargar las configuraciones de notificaciones.",
      saveError: "No se pudieron guardar las configuraciones. Los cambios han sido revertidos.",
      pushNotifications: "Notificaciones Push",
      chooseNotifications: "Elige qué notificaciones quieres recibir",
      mentions: "Menciones",
      mentionsDesc: "Cuando alguien te menciona en un comentario",
      replies: "Respuestas",
      repliesDesc: "Cuando alguien responde a tu comentario",
      subscriptions: "Suscripciones",
      subscriptionsDesc: "Cuando nuevo contenido coincide con tus palabras clave",
      newOffers: "Nuevas Ofertas",
      newOffersDesc: "Recibe notificaciones sobre nuevas ofertas, códigos promo y sorteos",
      votes: "Votos",
      votesDesc: "Cuando alguien vota por tu contenido",
      favorites: "Favoritos",
      favoritesDesc: "Cuando alguien añade tu contenido a favoritos",
      keywords: "Palabras Clave",
      keywordsDesc: "Notificaciones por palabras clave",
      emailNotifications: "Notificaciones por Email",
      receiveViaEmail: "Recibir notificaciones por correo electrónico",
      emailUpdates: "Actualizaciones por Email",
      emailUpdatesDesc: "Recibir notificaciones en tu correo electrónico",
      keywordNotifications: "Notificaciones Email por Palabras Clave",
      keywordNotificationsDesc: "Notificaciones por email para palabras clave",
    },
    header: {
      searchPlaceholder: "Buscar...",
    },
    notifications: {
      loading: "Cargando notificaciones...",
      empty_title: "Todo tranquilo",
      empty_message: "Las notificaciones aparecerán aquí",
      mark_all_read: "Leer todo",
      new_content_keyword: "Nuevo contenido para palabra clave: {{content}}",
      mentioned_you: "{{actor}} te mencionó en un comentario",
      replied_to_comment: "{{actor}} respondió a tu comentario",
      commented_on_post: "{{actor}} comentó en tu publicación",
      voted_on_comment: "{{actor}} votó tu comentario",
    },
    commentInput: {
      replying_to: "Respondiendo a:",
      reply_placeholder: "Escribir una respuesta...",
      placeholder: "Escribir un comentario...",
    },
    testing: {
      title: "Pruebas",
      subtitle: "Herramientas de Desarrollador",
    },
    splash: {
      loading: "Cargando la aplicación..."
    },
  },
}; 